export type PlanKey = "free" | "pro" | "business"

const LABELS: Record<PlanKey, string> = {
  free:     "フリー",
  pro:      "プロ",
  business: "ビジネス",
}

const PlanBadge = ({ plan }: { plan: PlanKey }) => (
  <span className={`member-badge member-badge--plan-${plan}`}>{LABELS[plan]}</span>
)

export default PlanBadge
